import React from 'react';
import { Box, Typography, Link } from '@mui/material';
// @ts-ignore - Unusual file extension
import kindertalesLogo from '../../assets/logo.png.kindertales';

const Footer: React.FC = () => {
  return (
    <Box
      component="footer"
      sx={{
        py: 2,
        px: 2,
        mt: 'auto',
        textAlign: 'center',
        borderTop: '1px solid rgba(0, 0, 0, 0.08)',
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
      }}
    >
      <Link
        href="https://www.kindertales.com"
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 0.75,
          textDecoration: 'none',
          color: '#666',
          opacity: 0.85,
          transition: 'opacity 0.2s ease-in-out',
          '&:hover': {
            opacity: 1,
            textDecoration: 'underline',
          },
        }}
      >
        <Typography
          variant="caption"
          sx={{
            fontSize: '0.75rem',
            color: '#666',
            fontWeight: 400,
          }}
        >
          Powered by
        </Typography>
        <img
          src="https://www.kindertales.com/hubfs/kindertales-logo-2021.svg"
          alt="Kindertales"
          style={{
            height: '18px',
            width: 'auto',
            objectFit: 'contain',
          }}
        />
      </Link>
    </Box>
  );
};

export default Footer;

